/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React, { useRef } from "react"
import { Form2 } from "@cd2/forms"
import { FileUploader } from "@cd2/fileboy-react"
import { IFileData } from "@cd2/fileboy-react/dist/types"
import { Spacer } from "@cd2/components"
import { FieldLabel } from "@cd2/forms/build/es6/Form2"

export function FileField({
  field,
  label,
  allow = "",
  required,
}: {
  field: string
  label?: React.ReactNode
  allow?: string[] | string
  required?: boolean
}) {
  const uploadingRef = useRef(false)
  const recordingRef = useRef(false)
  const formField = Form2.useField<string>(field)

  function handleFieldChange(value: IFileData) {
    formField.setValue(value.id)
    uploadingRef.current = false
  }

  Form2.useFormSubmitLock(async () => {
    if (recordingRef.current) {
      formField.setError("still being recorded!")
      return false
    }

    // if it is currently uploading then we return a promise and start an interval checking for
    // the upload completing. When the upload has finished the promise is resolved
    if (uploadingRef.current) {
      return new Promise(resolve => {
        const interval = setInterval(() => {
          if (!uploadingRef.current) {
            clearInterval(interval)
            resolve()
          }
        }, 100)
      })
    } else {
      if (required && !formField.getValue()) {
        formField.setError("must be present")
        return false
      } else {
        formField.setError("")
      }
    }
  })

  return (
    <div>
      {typeof label === "string" ? (
        <FieldLabel label={label} fieldName={""} required={required} />
      ) : (
        label
      )}
      <Spacer size={4} />
      <div css={css("display: flex")}>
        <FileUploader
          key={formField.getValue()}
          allow={allow}
          defaultFileId={formField.getValue()}
          onFileUploaded={handleFieldChange}
          onUploadStart={() => {
            uploadingRef.current = true
          }}
        />
      </div>
      {formField.getError() && (
        <div
          css={css`
            color: #ff4040;
            font-size: 0.9em;
            margin: 2px 0;
          `}
        >
          {formField.getError()}
        </div>
      )}
    </div>
  )
}
